export default __webpack_public_path__ + "c5c37ad9713a884687ca238e8f61b38a.png";